import { useRouter } from 'next/router';
import React from 'react';
import Link from 'next/link';
import { ShowMoreButton } from './ShowMore.styles';

export type ShowMoreProps = {
    allByDefault?: boolean;
    children: JSX.Element;
};

const ShowMore = ({ allByDefault, children }: ShowMoreProps) => {
    const router = useRouter();

    return router.query.info === 'visa' || allByDefault ? (
        children
    ) : (
        <Link
            href={{
                pathname: router.pathname,
                query: {
                    ...router.query,
                    info: 'visa',
                },
            }}
            passHref
            scroll={false}
        >
            <ShowMoreButton data-rt="video-page-show-more">Visa medverkande</ShowMoreButton>
        </Link>
    );
};

export default ShowMore;
